import { get } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Form, Button, Icon, Input } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ScheduleFilters extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    onFilterChange: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "filters"
  };

  constructor(props) {
    super(props);

    this.state = {
      filters: {
        name: get(props, "initialValues.filters.name", "") // used for initial basic search
      },
      view: get(props, "initialValues.view", "card")
    };
  }

  // -- HANDLERS--//

  onFilterChange = (evt, data) => {
    this.setState(
      { filters: { ...this.state.filters, [data.name]: data.value } },
      this.onStateChange
    );
  };

  onSearchChange = (evt, data) => {
    this.setState({
      filters: { ...this.state.filters, [data.name]: data.value }
    });
  };

  onViewChange = (evt, data) => {
    this.setState({ [data.name]: data.value }, this.onStateChange);
  };

  onResetFilters = () => {
    this.setState(
      {
        filters: {
          name: ""
        }
      },
      this.onStateChange
    );
  };

  onStateChange = () => {
    const { filters, view } = this.state;
    this.props.onFilterChange({ filters, view });
  };

  // -- RENDER --//

  render() {
    const { copyKey, copy } = this.props;
    const {
      filters: { name }
    } = this.state;

    // view fields removed until they're updated with new permissions implementation
    return (
      <Form size="mini" className="clearfix">
        <Form.Group inline className="search-group">
          <Form.Field
            control={Input}
            name="name"
            value={name}
            iconPosition="left"
            placeholder={copy(`${copyKey}.search.placeholder`)}
            onChange={this.onSearchChange}
            action
            className="flex-grow-1"
          >
            <Icon name="search" />
            <input />
            <Button size="tiny" compact onClick={this.onStateChange}>
              {copy(`${copyKey}.search.search_cta`)}
            </Button>
            <Button size="tiny" compact onClick={this.onResetFilters}>
              {copy(`${copyKey}.search.reset_cta`)}
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ScheduleFilters);
